import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BlogContent } from '@app/@shared/models/search/cti-search.model';
import { EntitlementService } from '@app/@shared/services/entitlement/entitlement.service';

@Component({
    selector: 'app-techstream-area',
    templateUrl: './techstream-area.component.html',
    styleUrls: ['./techstream-area.component.scss'],
    standalone: false
})
export class TechstreamAreaComponent {
  @Input() blogs: Array<BlogContent>;

  @Output() clickViewAll = new EventEmitter<void>();

  constructor(private router: Router, private entitlementService: EntitlementService) {}

  public onClickBlog(blog: BlogContent): void {
    if (!blog.entitled) {
      const modalTitle = `TechStream: ${blog.subscriptionName}: ${blog.name}`;
      this.entitlementService.openRequestAccessConfirmDialog(modalTitle);
    } else {
      const fragment = blog.subscriptionName? 'name=' + encodeURIComponent(blog.subscriptionName): '';
      this.router.navigate(blog.contentUrl, { fragment });
    }
  }

  public onClickViewAll(): void {
    this.clickViewAll.emit();
  }
}
